<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }} </span>
          </b-col>
        </b-row>

        <b-tooltip target="refresh" triggers="hover"
          >Click to refresh</b-tooltip
        >
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Date Order"
                  label-size="sm"
                >
                  <b-input-group>
                    <daterangepicker
                      size="sm"
                      ref="dateplaced"
                      v-model="dateplaced_at"
                      :opens="'right'"
                      :locale-data="locale_data"
                      :ranges="locale_ranges"
                      :linkedCalendars="true"
                    >
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="
                          dateplaced = {
                            startDate: null,
                            endDate: null,
                          }
                        "
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Your Ref / PO"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="yourref"
                      :debounce="options.debounce"
                      placeholder="Your Ref"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!yourref"
                        @click="yourref = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Client SL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select slac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="slac"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadSLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect
                    placeholder="Select status..."
                    v-model="status"
                    :clearable="true"
                    :options="status_options"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
                    <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect
                    placeholder="Select event..."
                    searchPromptText="Type at least 4 chars..."
                    v-model="eventcode"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadEvent"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="agent"
                      :debounce="options.debounce"
                      placeholder="Agent"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!agent"
                        @click="agent = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col
                    class="gridtoolbar"
                    cols="auto"
                    v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )"
                    :key="index"
                  >
                    <b-button
                      v-if="tool.type == 'button'"
                      :id="'tool_' + tool.action"
                      :size="tool.size"
                      :variant="tool.variant"
                      :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null"
                      :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)"
                    >
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col
                  cols="auto"
                  v-for="(tool, index) in options.view"
                  :key="index"
                >
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group
                    v-if="tool.type == 'radio-group'"
                    :options="tool.options"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div>
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                :sticky-header="btable_height + 'px'"
                striped
                hover
                small
                caption-bottom
                show-empty
                selectable
                select-mode="multi"
                :busy="btable_busy"
                :items="btable_items"
                :fields="options.fields"
                :filter="btable_find"
                @row-selected="btable_rowSelected"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="btable_iconselected()"
                    aria-hidden="true"
                    @click="btable_iconselectedClick()"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        btable_rowBadgeCell(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in btable_rowActionCell(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="btable_rowClick(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="
                                    btable_rowActionIcon(action, row.item)
                                  "
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="btable_rowClick(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>
      <div v-if="component">
        <component
          :is="component"
          :selection="btable_selected"
          :config="cconfig"
          @saveit="saveit"
          @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"
        ></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3" no-gutters>
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary"
            >Found {{ rows }} rows</span
          >
        </b-col>
        <b-col class="text-right">
          <b-pagination
            v-if="rows > limit"
            hide-ellipsis
            v-model="currentpage"
            :total-rows="rows"
            :per-page="limit"
            align="right"
            size="sm"
          ></b-pagination>
        </b-col>
        <b-col class="ml-2" cols="auto">
          <div class="pagelimit">
            <treeselect
              v-model="limit"
              :clearable="false"
              :options="options_pagesizes"
              size="sm"
              inline
            ></treeselect>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <!-- <Sidebardocuments
      :search="search"
      @discard="discard(row)"
      @refresh="refresh()"
    /> -->
  </div>
</template>
<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

import HotelRoomlistsEdit from "./Components/HotelRoomlistsEdit";
import HotelRoomlistsNotes from "./Components/HotelRoomlistsNotes";

export default {
  name: "Hotels",
  components: {
    HotelRoomlistsEdit,
    HotelRoomlistsNotes,
  },
  watch: {
    async dateplaced_at() {
      await this.load();
    },
    async yourref() {
      this.dateplaced_at.startDate = null;
      this.dateplaced_at.endDate = null;
      this.agent = null;
      await this.load();
    },

    async slac() {
      await this.load();
    },
    async eventcode() {
      await this.load();
    },
    async agent() {
      await this.load();
    },
    async status() {
      await this.load();
    },
  },
  data() {
    return {
      dateplaced_at: {
        startDate: this.$moment().add(-3, "months").format("YYYY-MM-DD"),
        endDate: this.$moment().add(6, "months").format("YYYY-MM-DD"),
      },
      slac: null,
      status: null,
      eventcode: null,
      yourref: null,

      agent: null,
      status_options: [
        { id: "1", label: "Active" },
        { id: "0", label: "Cancelled" },
        { id: "2", label: "Pending" },
      ],

      criteria: {
        events: [],
      },
      options: {
        title: "Hotel Roomlists",
        icon: "fa fa-list",
        debounce: 500,
        tools: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-commenting-o",
            position: "toolbar",
            action: "notes",
            label: "Notes",
            component: {
              name: "",
            },
          },
        ],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
              {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "yourref",
            label: "Your Ref / PO",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (value.length >= 30) {
                result = value.slice(0, 27) + " ...";
              }
              return result;
            },
          },
          {
            key: "dateplaced",
            label: "Date Placed",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
      
          {
            key: "eventname",
            label: "Name",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },

          // {
          //   key: "value",
          //   label: "Value",
          //   sortable: true,
          //   class: "text-right d-none d-sm-table-cell",
          // },
          // {
          //   key: "spent",
          //   label: "Spent",
          //   sortable: true,
          //   class: "text-right d-none d-sm-table-cell",
          // },

          {
            key: "status",
            label: "Status",
            class: "d-none d-sm-table-cell",
            sortable: true,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },

          {
            key: "actions",
            label: "Actions",
            class: "text-right actions w-80px",
          },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            Cancelled: "danger",
            Active: "success",
            Pending: "warning",
            formatter: (value, key, item) => {
              switch (value) {
                case "2":
                  return "Pending";
                case "0":
                  return "Cancelled";
                case "1":
                  return "Active";
                default:
                  return value;
              }
            },
          },
        ],
        actions: [
          // {
          //   key: "stages",
          //   label: "Payment Stages",
          //   icon: "fa fa-list-ol",
          //   single: true,
          //   multiple: false,
          //   component: {
          //     name: "OrdersStagesEdit",
          //   },
          // },
          // {
          //   key: "invoices",
          //   label: "Activity",
          //   icon: "fa fa-signal",
          //   single: true,
          //   multiple: false,
          //   component: {
          //     name: "OrdersInvoices",
          //   },
          // },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  computed: {
    readonly() {
      return this.user.rolename == "client";
    },
  },
  async mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "text-left actions",
        });
      }
    }

    this.$helpers.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,import,archive");
    this.toolComponents([
      { action: "add", name: "HotelRoomlistsEdit" },
      { action: "edit", name: "HotelRoomlistsEdit" },
      { action: "notes", name: "HotelRoomlistsNotes" },
    ]);

    if (this.user.rolename == "client") {
      this.slac = this.user.slac;
      this.toolRemove("add,notes");
      this.status = "1";
    } else {
      // this.agent = this.user.initials;

      this.options.actions.unshift({
        key: "edit",
        label: "Edit",
        icon: "fa fa-pencil",
        single: true,
        multiple: false,
        component: {
          name: "HotelRoomlistsEdit",
        },
      });

      this.options.actions.unshift({
        key: "download",
        label: "Download",
        icon: "fa fa-paperclip text-info",
        single: true,
        multiple: false,
        rule: "attachment",
      });

      if (this.user.permissions.includes("hotels.delete")) {
        this.options.actions.push({
          key: "deleteit",
          label: "Delete",
          icon: "fa fa-trash text-danger",
          single: true,
          multiple: true,
          overlay: {
            message: "Are you sure you want to delete %yourref% ?",
            buttons: [
              {
                label: "Yes",
                variant: "danger",
                dispatch: "delete",
              },
              {
                label: "No",
                class: "ml-2",
              },
            ],
          },
        });
      }
    }
    this.load();
  },

  methods: {
    async load(offset, limit) {
      if (!offset) {
        this.currentpage = 1;
        offset = 0;
      }

      this.btable_items = [];

      console.log("load()");
      // NO WILDCARD SEARCHES
      if (
        !this.dateplaced_at.startDate &&
        !this.dateplaced_at.endDate &&
        !this.yourref &&
        !this.slac &&
        !this.eventcode &&
        !this.status &&
        !this.agent
      ) {
        return;
      }

      this.btable_busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        dateplaced_at: [
          this.dateplaced_at.startDate,
          this.dateplaced_at.endDate,
        ],
        eventcode: this.eventcode,

        agent: this.agent,
        yourref: this.yourref,
        slac: this.slac,
        status: this.status,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels_old(
              $limit: Int
              $offset: Int
              $id: String
              $dateplaced_at: [String]
              $slac: String
              $yourref: String
              $eventcode: String
              $agent: String
              $status: String
              $dateformat: String
            ) {
              hotels_old(
                limit: $limit
                offset: $offset
                id: $id
                dateplaced_at: $dateplaced_at
                yourref: $yourref

                slac: $slac
                eventcode: $eventcode
                agent: $agent
                status: $status
                dateformat: $dateformat
              ) {
                id
                yourref

                slac
                dateplaced
                eventcode
                eventname
                # value
                # spent
                notes
                status
                attachment
                agent
                rows
              }
            }
          `,
          variables,
        });

        if (limit > this.limit) {
          return response.data.hotels_old;
        }

        this.btable_items = response.data.hotels_old;

        if (response.data.hotels_old.length > 0) {
          this.rows = response.data.hotels_old[0].rows;
        }

        // for (var k = 0; k < this.btable_items.length; k++) {
        //   if (this.btable_items[k].value && this.btable_items[k].spent) {
        //     this.btable_items[k].progress = (
        //       (this.btable_items[k].spent / this.btable_items[k].value) *
        //       100
        //     ).toFixed(2);
        //   }
        // }
      } catch (error) {
        console.log(error);
      }

      this.btable_busy = false;
    },
    async _toolClick(a) {
      console.log("local aa toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
        case "download":
          await this.download();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      switch (a) {
        case "notes":
          return this.btable_selected.length == 1 ? false : true;
      }
    },

    async download() {
      this.busy = true;
      let variables = {
        id: this.btable_selected[0].id,
        // documentformat: this.documentformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels_old($id: String) {
              hotels_old(id: $id) {
                id
                data
              }
            }
          `,
          variables,
        });
        if (response.data.hotels_old.length > 0) {
          if (response.data.hotels_old[0].data) {
            try {
              this.fileUpload = JSON.parse(response.data.hotels_old[0].data);
            } catch (error) {
              this.fileUpload = {
                name: response.data.hotels_old[0].yourref + ".pdf",
                data: response.data.hotels_old[0].data,
              };
            }
            await this.fileUpload_view();
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },

    async deleteit() {
      let rows = [];
      this.btable_selected.forEach(function (v) {
        rows.push({ id: v.id });
      });
      let variables = { rows };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation hotels_delete_old($rows: [Hotel_old_input]) {
              hotels_delete_old(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },
  },
};
</script>

<style>
</style>